import { render, staticRenderFns } from "./CsSolicitudesInternasServicios.vue?vue&type=template&id=209bba83"
import script from "./CsSolicitudesInternasServicios.vue?vue&type=script&lang=js"
export * from "./CsSolicitudesInternasServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports